module.exports = __webpack_public_path__ + "img/support.cdd022b.png";